module.exports = __webpack_public_path__ + "static/media/puls.ba0790b8.webp";